module.exports = __webpack_public_path__ + "img/Austria.da9f9de2.svg";